export const CitationRootSx = {
  breadcrumbsMainBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: { xs: 'flex-start', sm: 'space-between' },
    alignItems: { xs: 'flex-start', sm: 'center' },
    gap: { xs: '12px', sm: '0px' },
    marginBottom: { xs: '16px', sm: '0px' }
  },
  breadcrumbsContainer: {
    width: { xs: '100%', sm: 'auto' }
  },
  userTutorialBox: {
    display: 'flex',
    gap: { xs: '6px', sm: '8px' },
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer'
    },
    width: { xs: '100%', sm: 'auto' },
    justifyContent: { xs: 'flex-start', sm: 'flex-end' }
  },
  userTutorialIcon: {
    width: { xs: '18px', sm: '20px' },
    height: { xs: '18px', sm: '20px' }
  },
  userTutorial: {
    fontSize: { xs: '14px', sm: '16px' },
    lineHeight: { xs: '20px', sm: '24px' },
    textAlign: 'left',
    color: 'var(--color-purple-deep-alt)',
    fontFamily: 'Inter'
  },
  gridItem: {
    padding: 0,
    paddingLeft: { xs: '16px', sm: '32px' },
    paddingRight: { sm: '0px' }
  }
};
